const tour = {
  0: {
    name: 'Edit Tour',
    authRule: 'editTour'
  },
  1: {
    name: 'Delete Tour',
    authRule: 'addTour'
  },
  2: {
    name: 'Add Meal',
    authRule: ''
  },
  3: {
    name: 'Add Pay Transactions',
    authRule: ''
  },
  4: {
    name: 'Add Indicators',
    authRule: ''
  },
  5: {
    name: 'Add Assignment',
    authRule: ''
  },
  6: {
    name: 'Notifications Log',
    authRule: ''
  },
  7: {
    name: 'Change Day Type',
    authRule: 'changeDayType'
  },
  8: {
    name: 'Add Days Off Request',
    authRule: ''
  }
};

export default tour;



// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/context-menu-arrays/tour.js